"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOTHER_TYPE_OPTIONS = exports.MOTHER_STATUS_OPTIONS = exports.DESTRUCTION_REASON_OPTIONS = exports.DEFAULT_MOTHER_TYPE = void 0;
var MOTHER_STATUS_OPTIONS = [
    { label: "Active", value: "ACTIVE" },
    { label: "Regeneration", value: "REGENERATION" },
    { label: "Backup", value: "BACKUP" },
    { label: "Quarantine", value: "QUARANTINE" },
    { label: "Retired", value: "RETIRED" },
    { label: "Removed", value: "REMOVED" },
];
exports.MOTHER_STATUS_OPTIONS = MOTHER_STATUS_OPTIONS;
var MOTHER_TYPE_OPTIONS = [
    { label: "Active", value: "ACTIVE" },
    { label: "Replacement", value: "REPLACEMENT" },
    { label: "Regeneration", value: "REGENERATION" },
    { label: "Genetic Backup", value: "GENETIC_BACKUP" },
];
exports.MOTHER_TYPE_OPTIONS = MOTHER_TYPE_OPTIONS;
var DEFAULT_MOTHER_TYPE = "ACTIVE";
exports.DEFAULT_MOTHER_TYPE = DEFAULT_MOTHER_TYPE;
var DESTRUCTION_REASON_OPTIONS = [
    { label: "Pest / Disease", value: "PEST_DISEASE" },
    { label: "Quality", value: "QUALITY" },
    { label: "Regulatory", value: "REGULATORY" },
    { label: "Space / Capacity", value: "SPACE_CAPACITY" },
    { label: "Other", value: "OTHER" },
];
exports.DESTRUCTION_REASON_OPTIONS = DESTRUCTION_REASON_OPTIONS;
